<template>
  <div class="d-flex w-100">
    <slot></slot>
    <div class="p-1 px-4 bg-warning"></div>
    <div class="p-1 px-4 bg-danger"></div>
    <div class="flex-grow-1 bg-brand"></div>
  </div>
</template>